import React, { useMemo, useState, useEffect, useRef } from 'react'

import { buildEditorialLayout } from './utils/layoutEngine'
import './EditorialGrid.scss'
import EventCard from './Cards/EventGridCard'
import EventGridCardSkeleton from './Cards/EventGridCardSkeleton'

const EditorialGrid = ({
  events,
  loadNextPageData,
  currentPage,
  totalPages,
  onRegistrationChange,
  paginationLloading,
  setPaginationLloading
}) => {
  const [isMobile, setIsMobile] = useState(false)
  const [isTablet, setIsTablet] = useState(false)
  const loadMoreRef = useRef(null)

  useEffect(() => {
    const check = () => {
      setIsMobile(window.innerWidth <= 768)
      setIsTablet(window.innerWidth > 768 && window.innerWidth <= 1199)
    }

    check()
    window.addEventListener('resize', check)

    return () => window.removeEventListener('resize', check)
  }, [])

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const target = entries[0]

        if (
          target.isIntersecting &&
          currentPage < totalPages &&
          !paginationLloading
        ) {
          setPaginationLloading(true)
          loadNextPageData({ section: 'upcoming', pageNumber: currentPage + 1 })
        }
      },
      {
        root: null, // viewport
        rootMargin: '200px', // start loading a bit early
        threshold: 0
      }
    )

    if (loadMoreRef.current) {
      observer.observe(loadMoreRef.current)
    }

    return () => {
      observer.disconnect()
    }
    // }, [page, hasMore, loading])
  }, [currentPage, totalPages, paginationLloading, isMobile, isTablet])

  // DESKTOP: use layout engine
  const layout = useMemo(() => {
    return buildEditorialLayout(events)
  }, [events])

  // MOBILE: simple 1-column layout (ignore engine)
  if (isMobile || isTablet) {
    return (
      <div className='editorialGridMobile'>
        {events.map((event, index) => (
          <EventCard
            key={index}
            event={event}
            location='upcoming'
            position={index + 1}
            onRegistrationChange={onRegistrationChange}
          />
        ))}
        {paginationLloading &&
          Array.from({ length: 2 }).map((_, index) => (
            <EventGridCardSkeleton key={index} />
          ))}
        <div ref={loadMoreRef} style={{ height: '10px' }} />
      </div>
    )
  }

  return (
    <>
      <div className='editorialGrid'>
        {layout.map((item, index) => (
          <EventCard
            key={index}
            event={item?.event}
            location='upcoming'
            position={index + 1}
            onRegistrationChange={onRegistrationChange}
            className={`gridItem ${item.rowSpan === 2 ? 'featured' : ''}`}
            style={{
              gridRow: `${item.row + 1} / span ${item.rowSpan}`,
              gridColumn: `${item.col + 1} / span ${item.colSpan}`
            }}
          />
        ))}

        {paginationLloading &&
          Array.from({ length: 6 }).map((_, index) => (
            <EventGridCardSkeleton key={index} />
          ))}
      </div>
      <div ref={loadMoreRef} style={{ height: '10px' }} />
    </>
  )
}

export default EditorialGrid
